import type { components } from "@/api-schema";
import { getModelGenerationDatId } from "@/common/helpers/get-model-generation-dat-id";

type ModelGeneration = components["schemas"]["ModelGeneration"];
type ExistingModelGeneration = Pick<ModelGeneration, "uuid" | "name" | "vehicleKind"> & {
  modelFamily?: Pick<ModelGeneration["modelFamily"], "uuid">;
  modelGenerationIdentifiers?: Pick<ModelGeneration["modelGenerationIdentifiers"][number], "identifier" | "provider">[];
};

export function validateModelGenerationDuplicates(
  values: {
    uuid?: string;
    modelFamily?: string;
    vehicleKind?: ModelGeneration["vehicleKind"];
    name?: string;
    datId?: string;
  },
  existingModelGenerations: readonly ExistingModelGeneration[] = [],
) {
  const candidates = values.modelFamily
    ? existingModelGenerations.filter(
        (generation) =>
          generation.uuid !== values.uuid &&
          generation.modelFamily?.uuid === values.modelFamily &&
          generation.vehicleKind === values.vehicleKind,
      )
    : [];
  const name = values.name?.trim().toLowerCase();
  const datId = values.datId?.trim();

  return {
    hasDuplicateName: !!name && candidates.some((generation) => generation.name?.toLowerCase() === name),
    hasDuplicateDatId:
      !!datId &&
      candidates.some((generation) => getModelGenerationDatId(generation.modelGenerationIdentifiers)?.trim() === datId),
  };
}
